"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optStateReducer = exports.createInitialOptState = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _UIOptConstants = require("ui-addon-opt/constants/UIOptConstants");

var _OptActions = require("./OptActions");

var _OptState = require("./OptState");

var _UserState = require("./UserState");

var getTargetOptinView = function getTargetOptinView(state, previousOptinView) {
  if ((0, _OptState.isOptedIn)(state)) {
    return _UIOptConstants.OPTIN_VIEW_NEW;
  }

  if ((0, _OptState.isKnownState)(state)) {
    return _UIOptConstants.OPTIN_VIEW_CURRENT;
  }

  return previousOptinView || _UIOptConstants.OPTIN_VIEW_CURRENT;
};

var initFromSettings = function initFromSettings(settings) {
  return {
    choice: null,
    optinView: getTargetOptinView(settings.availability.state),
    isSuperAdmin: (0, _UserState.isSuperAdmin)(settings.user),
    state: null
  };
};

var createInitialOptState = function createInitialOptState() {
  return {
    choice: null,
    optinView: null,
    isSuperAdmin: false,
    state: null
  };
};

exports.createInitialOptState = createInitialOptState;

var optStateReducer = function optStateReducer(state, action) {
  switch (action.type) {
    case _OptActions.ACTION_INIT_OPT:
      return (0, _extends2.default)({}, state, initFromSettings(action.settings));

    case _OptActions.ACTION_USER_OPT_IN:
      return (0, _extends2.default)({}, state, {
        choice: _OptState.OPT_CHOICE_USER_OPT_IN
      });

    case _OptActions.ACTION_USER_OPT_OUT:
      return (0, _extends2.default)({}, state, {
        choice: _OptState.OPT_CHOICE_USER_OPT_OUT
      });

    case _OptActions.ACTION_HUB_OPT_IN:
      return (0, _extends2.default)({}, state, {
        choice: _OptState.OPT_CHOICE_HUB_OPT_IN
      });

    case _OptActions.ACTION_HUB_OPT_OUT:
      return (0, _extends2.default)({}, state, {
        choice: _OptState.OPT_CHOICE_HUB_OPT_OUT
      });

    case _OptActions.ACTION_REJECT:
      return (0, _extends2.default)({}, state, {
        choice: _OptState.OPT_CHOICE_REJECT
      });

    case _OptActions.ACTION_STATE_UPDATED:
      return (0, _extends2.default)({}, state, {
        choice: null,
        optinView: getTargetOptinView(state.choice, state.optinView),
        state: state.choice
      });

    case _OptActions.ACTION_CHOICE_RESET:
      return (0, _extends2.default)({}, state, {
        choice: null
      });

    default:
      throw new Error("Invalid opt action: " + action.type);
  }
};

exports.optStateReducer = optStateReducer;